<template lang='pug'>
.fpui-status-dataprocessing(:class='{ active: active, standalone: standalone }')
  status-value(:value='getBytes(inValue+out)', v-show='!active')
  .in-and-out(v-show='active')
    div.container-value(ref='in')
      b {{ 'fpui.monitoring.dataplant.dataprocessing.in' | translate }} :
      span &nbsp;{{ getBytes(inValue) }}&nbsp;
      i.fa.fa-long-arrow-down
    div.container-value(ref='out')
      b {{ 'fpui.monitoring.dataplant.dataprocessing.out' | translate }} :
      span &nbsp;{{ getBytes(out) }}&nbsp;
      i.fa.fa-long-arrow-up
</template>

<script>
import Bytes from '@/shared/filters/Bytes'
import StatusValue from './StatusValue'
export default {
  components: { StatusValue },
  props: {
    inValue: Number,
    out: Number,
    active: Boolean,
    standalone: Boolean
  },
  methods: {
    getBytes (value) { return `${Bytes(value)}` }
  }
}
</script>

<style lang='less'>
  .fpui-status-dataprocessing {
    font-size: 15px;
    .in-and-out {
      .container-value {
        position: relative;
        i.fa {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    &.active {
      margin-top: 0;
      height: 120px;
      position: relative;
      line-height: 30px;
      .in-and-out {
        width: 130%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        margin-left: -15%;
      }
    }
  }
</style>
